<template>
    <outboxCon :bg="bg">
        <div class="teacher-methods">
            <app-title :main="main" :sub="sub"></app-title>
            <methosScroll :imgList="config.imgList" :navList="config.navList" :sectionHeight="config.sectionHeight" :boxHeight="config.boxHeight" :id="config.id"></methosScroll>
        </div>
    </outboxCon>
</template>
<script>
import methosScroll from './hashScroll/methodScroll'
export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    bg: {
      type: String,
      default: ''
    },
    main: {
      type: String,
      default: ''
    },
    sub: {
      type: String,
      default: ''
    }
  },
  components: { methosScroll }
}
</script>
<style lang="scss" scoped>
    .teacher-methods{
        width: $main-width;
        margin: 0 auto;
        padding: 50px 0px 81px 82px;
        position: relative;
    }
</style>
